import { render, staticRenderFns } from "./Season.vue?vue&type=template&id=1aab4796"
import script from "./Season.vue?vue&type=script&lang=js"
export * from "./Season.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports